export function shouldUseOwnCommunicationHighlights(
  isAdmin: boolean,
  isOrgContext: boolean,
): boolean {
  return !(isAdmin && isOrgContext);
}
